<template>
<el-carousel height="350px" type="card">
  <el-carousel-item v-for="item in banners" :key="item.image_url" >
    <div>
      <a :href="item.link_url">
        <el-image class="banner-image" :src="item.image_url" fit="fit" />
      </a>
    </div>
  </el-carousel-item>
</el-carousel>
</template>

<script>
export default {
  data() {
    return {
      banners: [],
    };
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData(){
      const that = this
      that.axios.get('/homepage/banner/list')
      .then(res =>{
        let {code, data, message} = res;
        if(code===0){
          that.banners = data
        }else{
          that.$message(message);
        }
      })
    },
  }
}
</script>

<style lang="stylus" scoped>

</style>